import React, { useState, useEffect, useContext } from "react";
import { AppLoad } from "../../../core/AppLoad";
import { AppConfig, AppStateContext } from "../../../app-state";
import { Spinner } from "../../../core/Spinner";
import { useParams, useHistory } from "react-router-dom";
import { getRoleLabel } from "../../../enums/roles";
export const Profile = () => {
    const { state, dispatch } = useContext(AppStateContext);
    const [loadState, setLoadState] = useState('firstLoad'); // firstLoad | loading | loaded
    const [accountData, setAccountData] = useState({});
    const { urlAccountId } = useParams();
    const history = useHistory();
    const loadEvents = () => {
        AppLoad(AppConfig.APIUrl + 'secured/profile/detail', { accountId: urlAccountId }).then((Response) => {
            if (Response.status == 'error') {
                alert(Response.message);
            }
            else if (Response.status == 'ok') {
                setAccountData(Response.UserData);
                setLoadState('loaded');
            }
        });
    };
    const eraseAccount = () => {
        if (!confirm("Opravdu si přejete uživatele odstranit?"))
            return false;
        AppLoad(AppConfig.APIUrl + 'admin/user-management/Erase', { ids: urlAccountId }).then((Response) => {
            if (Response.status == 'error') {
                alert(Response.message);
            }
            else if (Response.status == 'ok') {
                history.push("/cs/sekce/sprava-uzivatelu/admin");
            }
        });
    };
    useEffect(loadEvents, []);
    var ProfileHtml = null;
    switch (accountData.role) {
        case 'admin':
            ProfileHtml = React.createElement("div", null,
                React.createElement(React.Fragment, null,
                    React.createElement("dt", null, "Jm\u00E9no a p\u0159\u00EDjmen\u00ED"),
                    React.createElement("dd", null, accountData.fullname),
                    React.createElement("dt", null, "Email"),
                    React.createElement("dd", null, accountData.email),
                    React.createElement("dt", null, "Telefonn\u00ED kontakt"),
                    React.createElement("dd", null, accountData.phone)));
            break;
        case 'individual':
            ProfileHtml = React.createElement("div", null,
                React.createElement(React.Fragment, null,
                    React.createElement("dt", null, "Jm\u00E9no a p\u0159\u00EDjmen\u00ED"),
                    React.createElement("dd", null, accountData.fullname),
                    React.createElement("dt", null, "Email"),
                    React.createElement("dd", null, accountData.email),
                    React.createElement("dt", null, "Telefonn\u00ED kontakt"),
                    React.createElement("dd", null,
                        accountData.phone ? accountData.phone : '---',
                        "\u00A0"),
                    React.createElement("dt", null, "Adresa"),
                    React.createElement("dd", null,
                        accountData.street,
                        React.createElement("br", null),
                        accountData.zip,
                        " ",
                        accountData.city),
                    React.createElement("dt", null, "Rodn\u00E9 \u010D\u00EDslo"),
                    React.createElement("dd", null, accountData.bornId)));
            break;
        case 'legal':
            ProfileHtml = React.createElement("div", null,
                React.createElement(React.Fragment, null,
                    React.createElement("dt", null, "Obchodn\u00ED firma"),
                    React.createElement("dd", null, accountData.company),
                    React.createElement("dt", null, "Email"),
                    React.createElement("dd", null, accountData.email),
                    React.createElement("dt", null, "Telefonn\u00ED kontakt"),
                    React.createElement("dd", null, accountData.phone),
                    React.createElement("dt", null, "S\u00EDdlo"),
                    React.createElement("dd", null, accountData.address),
                    React.createElement("dt", null, "I\u010C"),
                    React.createElement("dd", null, accountData.regno),
                    React.createElement("dt", null, "DI\u010C"),
                    React.createElement("dd", null, accountData.vat),
                    React.createElement("dt", null, "Statut\u00E1rn\u00ED z\u00E1stupce"),
                    React.createElement("dd", null, accountData.statutory)));
            break;
    }
    return (React.createElement("div", { className: "container" },
        React.createElement("div", { className: "cms-article cms-single-panel" },
            React.createElement("h1", null, "Profil u\u017Eivatele"),
            loadState == 'firstLoad' ?
                React.createElement(Spinner, { large: true })
                :
                    React.createElement(React.Fragment, null,
                        React.createElement("dl", null,
                            ProfileHtml,
                            React.createElement("dt", null, "Typ u\u017Eivatele"),
                            React.createElement("dd", null, getRoleLabel(accountData.role))),
                        state.user.role == 'admin' &&
                            React.createElement("div", { className: "mt-24" },
                                React.createElement("button", { className: "primary-button", onClick: () => eraseAccount() }, "Smazat \u00FA\u010Det"))))));
};
